var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"display-4 font-2xl my-3"},[_vm._v("Schedules")]),_c('schedule-server-table',{ref:"schedules-table",attrs:{"filter_date":_vm.selected_date_obj,"collection_status":"Approved","filterable":[],"show_buttons":false,"route_override":true},on:{"pushRoute":(id) => _vm.$router.push(`/instrument-runner/${id}`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }